import { rolePermission } from '@/api/permission.js'
import { logouserinfo } from '@/api/zout/index.js'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    istrue: true, // 动态切换卡片列表
    showtitle: true,
    // 触发查询
    issearch:true,
      // 用户身份信息
    adminuserinfo: {},
    // 路由权限
    adminrouterlist: [],
  },
  getters: {
  },
  mutations: {
    SET_Istrue: (state, data) => {
      state.istrue = data
    },
    SET_Showtitle: (state, data) => {
      state.showtitle = data
    },
    SET_issearch: (state, data) => {
      state.issearch = data
    },
    // 身份信息
    SET_adminuserinfo: (state, data) => {
      state.adminuserinfo = data
    },
    // 路由模块
    SET_routerlist: (state, data) => {
      state.adminrouterlist = data
      sessionStorage.setItem("usermenulist", JSON.stringify(data))
    },
  },
  actions: {
    // 路由权限
    Getadminuserinfo(context, val) {
      logouserinfo()
        .then(res => {
          if (res.status == 1) {
            context.commit("SET_adminuserinfo", res.data)
          } else if (res.status === -1) {
            Message({
              message: res.data.msg,
              type: 'error',
            })
          }
        })
        .catch(err => {
        });
    },

    // 路由权限
    Getmenuslist(context, val) {
      rolePermission()
        .then(res => {
          if (res.status == 1) {
            context.commit("SET_routerlist", res.data);
          }
        })
        .catch(err => {
        });
    },

  },
  modules: {
  }
})
